window.toastr = require("toastr");
$(document).ready(function() {
    // block inputs
    $(".number:input").keypress(function(e) {
        //if the letter is not digit then display error and don't type anything
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });
    $(".numberwithcolon:input").keypress(function(e) {
        var charCode = e.which || e.keyCode;
        //if the letter is not digit then display error and don't type anything
        if (
            charCode != 58 &&
            e.which != 8 &&
            e.which != 0 &&
            (e.which < 48 || e.which > 57)
        ) {
            return false;
        }
    });
    $(".alphnumeric:input").keypress(function(e) {
        var regex = new RegExp("^[a-zA-Z0-9]+$");
        var keyCode = !e.charCode ? e.which : e.charCode;
        var str = String.fromCharCode(keyCode);
        //        console.log(str + " - "+ keyCode);
        if (regex.test(str) || keyCode == 8 || keyCode == 0) {
            return true;
        }
        e.preventDefault();
        return false;
    });
    //toastr configuration
    toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-left",
        timeOut: "1000",
        progressBar: true,
        showDuration: "300",
        hideDuration: "300",
    };
    //validator messages
    $.validator.addMethod(
        "emptyValue",
        function(value, element) {
            return !value.trim().length <= 0;
        },
        "Empty Values Not Allowed"
    );
    $.validator.addMethod(
        "packagePrice",
        function(value, element) {
            return value != 0;
        },
        "Package Price Cannot Be 0"
    );
    $.validator.addMethod(
        "decimalValue",
        function(value, element) {
            var specialChar = /^[0-9]*$/;
            if (!specialChar.test(value)) {
                return false;
            } else {
                return true;
            }
        },
        "Decimal value not allowed"
    );

    $.validator.addMethod(
        "custEmail",
        function(value, element) {
            if (value == "") {
                return true;
            }
            var mailValidate = /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
                value
            );
            return mailValidate;
        },
        "Invalid Email ID. Try again!"
    );
    /*$.validator.addMethod("custMultiEmail", function (value, element) {
     var valid = true;
     var emails = value.split(',');
     $.each(emails,function(i, emailId){
     valid = /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(emailId);
     return valid;
     });
     }, "Invalid Email ID. Try again!");*/
    $.validator.addMethod(
        "customPassword",
        function(value, element) {
            return value.trim().length >= 6;
        },
        "Min 6 char"
    );
    $.validator.addMethod(
        "number",
        function(value, element) {
            return !isNaN(value);
        },
        "Should be number or digits only"
    );
    $.validator.addMethod(
        "age",
        function(value, element) {
            return isNaN(value) || value < 150;
        },
        "Should be number or digits only"
    );
    $.validator.addMethod("noSpecialChar", function(value, element) {
        if (!value) {
            return true;
        }
        return /^[a-zA-Z0-9\._-\s]+$/g.test(value);
    });
    $.validator.addMethod(
        "onlyPossitiveNumber",
        function(value, element) {
            var mobileValidate = /^[1-9][0-9]*$/.test(value);
            return mobileValidate;
        },
        "Minimum value is 1"
    );
    $.validator.addMethod(
        "noSpace",
        function(value, element) {
            return value.indexOf(" ") < 0 && value != "";
        },
        "No space allowed"
    );
    $.validator.addMethod(
        "custMobile",
        function(value, element) {
            var mobileValidate = /^$|^[6-9][0-9]{9}$/.test(value);
            return mobileValidate;
        },
        "invalid Number"
    );
    $.validator.addMethod(
        "custRequestDemoMobile",
        function(value, element) {
            var mobileValidate = /^$|^[0-9]{7,15}$/.test(value);
            return mobileValidate;
        },
        "invalid Number"
    );
    $.validator.addMethod(
        "custNewMobile",
        function(value, element) {
            let mobileValidate = /^$|^[0-9]{7,15}$/.test(value);
            return mobileValidate;
            // if (window.userCurrency.centerName === "India") {
            //     mobileValidate = /^$|^[6-9][0-9]{9}$/.test(value);
            // } else {
            //     return /^$|^[0-9]{7,15}$/.test(value);
            // }
            // return mobileValidate;
        },
        "invalid Number"
    );
    $.validator.addMethod(
        "custBahrainMobile",
        function(value) {
            return /^$|^[0-9]{8}$/.test(value);
        },
        "invalid Number"
    );
    $.validator.addMethod(
        "custFinlandMobile",
        function(value) {
            return /^$|^[0-9]{9}$/.test(value);
        },
        "invalid Number"
    );
    $.validator.addMethod(
        "custBotswanMobile",
        function(value) {
            return /^(\d{7}|\d{8})$/.test(value);
        },
        "invalid Number"
    );
    $.validator.addMethod(
        "custNepalMobile",
        function(value) {
            return /^$|^[0-9]{10}$/.test(value);
        },
        "invalid Number"
    );
    $.validator.addMethod(
        "eitherEmailOrMobile",
        function(value, element) {
            var validElem = false;
            $(".eitherEmailOrMobile").each(function() {
                validElem = validElem || ($.trim($(this).val()) ? true : false);
            });
            return validElem;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i> Either Email Or Mobile is required"
    );
    $.validator.addMethod(
        "bothEmailAndMobile",
        function(value, element) {
            var validElem = true;
            $(".bothEmailAndMobile").each(function() {
                validElem = validElem && ($.trim($(this).val()) ? true : false);
            });
            return validElem;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i> Both Email And Mobile is required"
    );
    $.validator.addMethod(
        "customName",
        function(value, element) {
            if (value.trim().length == 0) {
                return true;
            }
            return value.trim().length >= 2 && value.trim().length <= 64;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i> Between 2- 64 char"
    );
    $.validator.addMethod(
        "lengthBetween",
        function(value, element) {
            var min = $(element).data("lengthmin"),
                max = $(element).data("lengthmax");
            if (!(min || max)) {
                return true;
            } else {
                return value.trim().length >= min && value.trim().length <= max;
            }
        },
        function(params, element) {
            var min = $(element).data("lengthmin"),
                max = $(element).data("lengthmax");
            return (
                "<i class='fa fa-info-circle' aria-hidden='true'></i> Between " +
                min +
                "- " +
                max +
                " char"
            );
        }
    );

    $.validator.addMethod(
        "length",
        function(value, element) {
            var len = $(element).data("length");
            console.log(len);
            if (!len) {
                return true;
            } else {
                return value.trim().length == len;
            }
        },
        function(params, element) {
            var len = $(element).data("length");
            return (
                "<i class='fa fa-info-circle' aria-hidden='true'></i> Should have " +
                len +
                " characters"
            );
        }
    );

    $.validator.addMethod(
        "isEmailOrMobile",
        function(value, element) {
            isMobile = /^[0-9]{8,10}$/.test(value);
            isEmail = /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
                value
            );
            console.log("checking login validation", isMobile);
            return isMobile || isEmail;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i> Either Email Or Mobile should be valid"
    );
    $.validator.addMethod(
        "isValidIp",
        function(value, element) {
            ipRegEx = /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/.test(
                value
            );
            return ipRegEx;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i> Please enter a valid Ip Address"
    );
    $.validator.addMethod(
        "isValidUrl",
        function(value, element) {
            urlRegEx = /^(http|https)?:\/\/[a-zA-Z0-9-\.]+\.[a-z]{2,4}$/.test(
                value
            );
            ipRegEx = /^(http|https)?:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/.test(
                value
            );
            return urlRegEx || ipRegEx;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i> Please enter a valid DNS Address"
    );
    $.validator.addMethod(
        "latitude",
        function(value, element) {
            latitudeEx = /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{7,15})?))$/.test(
                value
            );
            return latitudeEx && value != 0;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i>Not Valid"
    );
    $.validator.addMethod(
        "longitude",
        function(value, element) {
            longitudeEx = /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{7,15})?))$/.test(
                value
            );
            return longitudeEx && value != 0;
        },
        "<i class='fa fa-info-circle' aria-hidden='true'></i>Not Valid"
    );
    $.validator.addMethod(
        "min-val",
        function(value, element) {
            var minValue = Number($(element).data("min"));
            return value >= minValue;
        },
        function(params, element) {
            var minValue = $(element).data("min");
            return (
                "<i class='fa fa-info-circle' aria-hidden='true'></i> Minimum value " +
                minValue
            );
        }
    );
});

var customErrorPlacement = function(error, element) {
    var isCustomLabel =
        element.hasClass("eitherEmailOrMobile") ||
        element.hasClass("bothEmailAndMobile");
    if (isCustomLabel) {
        var errorContainer = element.data("error-cont");
        var prevError = $("#" + errorContainer).html();
        var currError = error.html();
        $("#" + errorContainer).empty();
        $("#" + errorContainer).html(currError);
    } else {
        error.insertBefore(element);
    }
};

module.exports = {
    formIsValid: function(formId, ignore) {
        ignore = ignore || "";
        var validObj = false;
        var formSel = $("form#" + formId);
        if (ignore == "") {
            validObj = formSel.validate({
                debug: true,
                errorClass: "error",
                errorPlacement: customErrorPlacement,
                success: function() {},
            });
        } else {
            validObj = formSel.validate({
                debug: true,
                ignore: ":hidden",
                errorClass: "error",
                errorPlacement: customErrorPlacement,
                success: function() {},
            });
        }

        formSel.find(".required").each(function() {
            $(this).rules("add", {
                required: true,
                emptyValue: true,
                messages: {
                    required:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Required",
                    emptyValue:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Empty Values Not Allowed",
                },
            });
        });
        formSel.find(".reqMobileOrMail").each(function() {
            $(this).rules("add", {
                required: true,
                messages: {
                    required:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Required either email or mobile",
                },
            });
        });
        formSel.find(".number").each(function() {
            $(this).rules("add", {
                number: true,
                messages: {
                    number:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Should be number or digits only",
                },
            });
        });

        formSel.find(".digits").each(function() {
            $(this).rules("add", {
                digits: true,
                messages: {
                    number:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Should be digits only",
                },
            });
        });

        formSel.find(".age").each(function() {
            $(this).rules("add", {
                age: true,
                messages: {
                    age:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Should be less than 150",
                },
            });
        });

        formSel.find(".equalTo").each(function() {
            var equalId = $(this).data("equaltoid");
            if (typeof equalId != "undefined") {
                $(this).rules("add", {
                    equalTo: "#" + equalId,
                    messages: {
                        equalTo:
                            "<i class='fa fa-info-circle' aria-hidden='true'></i> Mismatch",
                    },
                });
            }
        });
        formSel.find(".password").each(function() {
            $(this).rules("add", {
                customPassword: true,
                messages: {
                    customPassword:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Min 6 character",
                },
            });
        });
        formSel.find(".email").each(function() {
            $(this).rules("add", {
                custEmail: true,
                messages: {
                    custEmail:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid Email ID. Try again!",
                },
            });
        });
        formSel.find(".mobile").each(function() {
            $(this).rules("add", {
                custNewMobile: true,
                messages: {
                    custNewMobile:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid Mobile Number",
                },
            });
        });

        formSel.find(".eitherEmailOrMobile").each(function() {
            var validateEmail = $(this).data("type") == "email" ? true : false;
            var validateMobile =
                $(this).data("type") == "mobile" ? true : false;
            console.log(validateEmail, validateMobile);
            $(this).rules("add", {
                eitherEmailOrMobile: true,
                custEmail: validateEmail,
                custNewMobile: validateMobile,
                messages: {
                    eitherEmailOrMobile:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Either Email Or Mobile is required",
                    custEmail:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid Email ID!",
                    custNewMobile:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid Mobile Number!",
                },
            });
        });

        formSel.find(".isEmailOrMobile").each(function() {
            $(this).rules("add", {
                isEmailOrMobile: true,
                messages: {
                    isEmailOrMobile:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Either Email Or Mobile should be valid",
                },
            });
        });

        formSel.find(".bothEmailAndMobile").each(function() {
            var validateEmail = $(this).data("type") == "email" ? true : false;
            var validateMobile =
                $(this).data("type") == "mobile" ? true : false;
            $(this).rules("add", {
                bothEmailAndMobile: true,
                custEmail: validateEmail,
                custNewMobile: validateMobile,
                messages: {
                    bothEmailAndMobile:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Both Email And Mobile is required",
                    custEmail:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid Email ID!",
                    custNewMobile:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid Mobile Number!",
                },
            });
        });

        formSel.find(".eitherMobile").each(function() {
            var requiredField = $(this).data("either")
                ? !$("#" + $(this).data("either")).val()
                : true;
            $(this).rules("add", {
                required: requiredField,
                messages: {
                    required:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Either Email Or Mobile is required",
                },
            });
        });
        formSel.find(".eitherEmail").each(function() {
            var requiredField = $(this).data("either")
                ? !$("#" + $(this).data("either")).val()
                : true;
            $(this).rules("add", {
                required: requiredField,
                messages: {
                    required:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Either Email Or Mobile is required",
                },
            });
        });

        formSel.find(".custMultiEmail").each(function() {
            $(this).rules("add", {
                custMultiEmail: true,
                messages: {
                    custMultiEmail: "Invalid Email ID",
                },
            });
        });

        formSel.find(".noSpecialChar").each(function() {
            $(this).rules("add", {
                noSpecialChar: true,
                messages: {
                    noSpecialChar:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Only alphanumeric characters are allowed",
                },
            });
        });

        formSel.find(".noSpace").each(function() {
            $(this).rules("add", {
                noSpace: true,
                messages: {
                    noSpace:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> No space allowed",
                },
            });
        });

        var requiredGroup = [];
        formSel.find(".requiredGroup").each(function() {
            requiredGroup[$(this).data("reqgrp")] = $(this).data("reqgrp");
        });
        for (var item in requiredGroup) {
            var grpClass = requiredGroup[item];
            var isRequired = $("." + grpClass + ":filled").length == 0;
            formSel.find("." + grpClass).each(function() {
                $(this).rules("add", {
                    required: isRequired,
                    messages: {
                        required: "Either email or mobile is required",
                    },
                });
            });
        }
        var requiredRadioGroup = [];
        formSel.find(".requiredRadioGroup").each(function() {
            requiredRadioGroup[$(this).data("reqgrp")] = $(this).data("reqgrp");
        });
        for (var item in requiredRadioGroup) {
            var grpClass = requiredRadioGroup[item];
            var isRadioRequired = $("." + grpClass + ":checked").length == 0;
            formSel.find("." + grpClass).each(function() {
                $(this).rules("add", {
                    required: isRadioRequired,
                    messages: {
                        required: "Select One",
                    },
                });
            });
        }
        if (validObj.form()) {
            return true;
        }
        return false;
    },
    resetFormValidationErrors: function(formId) {
        var formSel = $("form#" + formId);
        formSel.validate().resetForm();
    },
    validateEmail: function(value) {
        var regex = /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
        return regex.test($.trim(value)) ? true : false;
    },

    validateEmails: function(string) {
        var self = this;
        var result = string.replace(/\s/g, "").split(/,|;/);

        for (var i = 0; i < result.length; i++) {
            result[i] = $.trim(result[i]);
            if (result[i] && !self.validateEmail(result[i])) {
                return false;
            }
        }

        return true;
    },
    sendEmailValidation: function(formId) {
        var self = this;
        var formSel = $("form#" + formId);
        var doSubmit = true;
        formSel.find(".required").each(function(i, element) {
            if ($.trim($(element).val()) == "") {
                var error_message =
                    $(element).data("message") !== undefined
                        ? $(element).data("message")
                        : "Required field: " +
                          $(element)
                              .attr("name")
                              .toUpperCase();
                toastr["error"](error_message);
                doSubmit = false;
                return false;
            }
        });
        if (!doSubmit) {
            return false;
        }
        formSel.find(".custEmail").each(function(i, element) {
            if (
                $.trim($(element).val()) != "" &&
                !self.validateEmails($(element).val())
            ) {
                toastr["error"]("Enter valid email id");
                doSubmit = false;
                return false;
            }
        });
        if (!doSubmit) {
            return false;
        }
        formSel.find(".check").each(function(i, element) {
            if ($.trim($(element).val()) == "") {
                if (
                    !confirm(
                        "Are you sure you want to send the email without " +
                            $(element).attr("name") +
                            "?"
                    )
                ) {
                    doSubmit = false;
                    return false;
                }
            }
        });
        if (!doSubmit) {
            return false;
        }
        return true;
    },
    customValidateMultiSelect: function(elemArray) {
        var customValidateElements = elemArray;
        var customValidate = true;
        $.each(customValidateElements, function(i, elem) {
            var element = $("#" + elem + "-multiselect");
            //console.log($(element.find('.multiselect__content')[0]).find('li.multiselect__element span.multiselect__option--selected').length);
            if (
                $(element.find(".multiselect__content")[0]).find(
                    "li.multiselect__element span.multiselect__option--selected"
                ).length == 0
            ) {
                if ($("#" + elem + "-error").length == 0) {
                    var error_html =
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Required";
                    var label_html =
                        "<label id='" +
                        elem +
                        "-error' for='" +
                        elem +
                        "' class='error'>" +
                        error_html +
                        "</label>";
                    $(label_html).insertBefore($("#" + elem + "-multiselect"));
                } else {
                    var error_html =
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Required";
                    $("#" + elem + "-error")
                        .html(error_html)
                        .show();
                }
                customValidate = customValidate && false;
            } else {
                customValidate = customValidate && true;
                if ($("#" + elem + "-error").length != 0) {
                    $("#" + elem + "-error").remove();
                }
            }
        });
        return customValidate;
    },
};
